import { Col, Form, Row } from "react-bootstrap";
import styles from "../nfse.module.css";
import dayjs from "dayjs";

export default function EventosNFSe({ show, nota }: iProps) {
    const eventosAux: any[] = nota.eventos

    if (show === false || eventosAux.length === 0) {
        return (<div></div>)
    }
    
    return (
        <div>
            <div style={{ "display": show ? "block" : "none" }}>
                {
                    eventosAux.map((evento: any, idx: number, arr: any[]) => {
                        let evento_motivo = ""
                        if (evento.evento_motivo_cod === 1) {
                            evento_motivo = "Erro na emissão"
                        }
                        if (evento.evento_motivo_cod === 2) {
                            evento_motivo = "Serviço não Prestado"
                        }
                        if (evento.evento_motivo_cod === 9) {
                            evento_motivo = "Outros"
                        }
                        return (
                            <Row key={idx} id={styles.identificacao_nfse} className="mb-15-forms" style={{ display: "flex" }}>
                                <h2 id={styles.identificacao_nfse_title}>{evento.evento_nome}</h2>
                                <Col className="col-4">
                                    <Form.Group>
                                        <Form.Label>Evento:</Form.Label>
                                        <Form.Control name='evento_nome' type="text" id='evento_nome' value={evento.evento_descricao} readOnly />
                                    </Form.Group>
                                </Col>
                                <Col className="col-1">
                                    <Form.Group>
                                        <Form.Label>Status:</Form.Label>
                                        <Form.Control name='evento_status' type="text" id='evento_status' value={evento.status} readOnly />
                                    </Form.Group>
                                </Col>
                                <Col className="col-2">
                                    <Form.Group>
                                        <Form.Label>Data enviado:</Form.Label>
                                        <Form.Control name='evento_data_envio' type="text" id='evento_data_envio' value={dayjs(evento.data_envio).format("DD/MM/YYYY HH:mm:ss")} readOnly />
                                    </Form.Group>
                                </Col>
                                <Col className="col-2">
                                    <Form.Group>
                                        <Form.Label>Motivo:</Form.Label>
                                        <Form.Control name='evento_motivo_cod_descricao' type="text" id='evento_motivo_cod_descricao' value={evento_motivo} readOnly />
                                    </Form.Group>
                                </Col>
                                <Col className="col-3">
                                    <Form.Group>
                                        <Form.Label>Justificativa:</Form.Label>
                                        <Form.Control as="textarea" rows={1} name='evento_motivo_descricao' id='evento_motivo_descricao' readOnly value={evento.evento_motivo_descricao} />
                                    </Form.Group>
                                </Col>
                            </Row>
                        )
                    })
                }
            </div>
        </div>
    )
}
interface iProps {
    show: boolean
    nota: any
}
